import apiClient from '@/services/axios'
import { listAllDistricts } from '../district/district'
import { geocode } from '@/utils'

export function getAllBuildings() {
  return apiClient.get('/buildings')
}

export function getBuildings(filter) {
  return apiClient.post('/buildings/searchBuildings', filter)
}

export function createBuilding(building) {
  return apiClient.post('/buildings', building)
}

export function updateBuilding({ id, ...building }) {
  return apiClient.patch(`/buildings/${id}`, building)
}

export function updateBuildingGeometry({ id, ...building }) {
  return apiClient.patch(`/buildings/${id}/geometry`, building)
}

export function getBuildingById(id) {
  return apiClient.get(`/buildings/${id}`)
}

// The building's times ("3:10 PM Regular dismissal"...): each a start or a
// dismissal (`kind`), one default of each (`isDefault`, `source: 'bell'`),
// offered as weekday time options in the route Set Schedule modal. A building
// with no default of a kind yet shows its bell as a virtual entry (id: null).
export function getBuildingTimes(id) {
  return apiClient.get(`/buildings/${id}/times`)
}

// The building's sessions ("Madison AM PK"...), A-Z: which of its students a
// routing group routes. Picked per student on the student form.
export function getBuildingSessions(id) {
  return apiClient.get(`/buildings/${id}/sessions`)
}

// `kind` and `isDefault` are optional: the Set Schedule modal sends neither
// (the server takes the kind from the hour). undefined fields are not sent.
export function createBuildingTime(id, { time, name, days, kind, isDefault }) {
  return apiClient.post(`/buildings/${id}/times`, {
    time,
    name,
    days,
    kind,
    isDefault,
  })
}

// Building Rules edit in the profile drawer - send only what changed.
export function updateBuildingTime(
  id,
  timeId,
  { time, name, days, kind, isDefault },
) {
  return apiClient.patch(`/buildings/${id}/times/${timeId}`, {
    time,
    name,
    days,
    kind,
    isDefault,
  })
}

// Soft removal: the row deactivates but saved route schedules keep their
// snapshotted time string.
export function deleteBuildingTime(id, timeId) {
  return apiClient.delete(`/buildings/${id}/times/${timeId}`)
}

/**
 * delete a building
 * @param {number} id
 * @returns
 */
export async function deleteBuilding(id) {
  return apiClient.delete(`/buildings/${id}`)
}

// TODO: create newly
export async function uploadExistingBuildingData(data) {
  try {
    const response = await listAllDistricts()
    const districts = response.data
    for (let s = 0; s < data.length; s++) {
      const element = data[s]
      const coordinates = await geocode(element.address.trim() || '')
      const matchingDistrict = districts.find(
        (district) => district.districtName === element.assignedDistrict.trim(),
      )

      let processedGrades = element.grades.trim()
      if (processedGrades === '12+') {
        processedGrades = '13'
      } else if (!processedGrades.includes('-')) {
        processedGrades = `${processedGrades}-${processedGrades}`
      }
      const toUploadData = {
        schoolYearActive: element.schoolYearActive.trim() || 'YES',
        summerActive: element.summerActive.trim() || 'NO',
        address: element.address.trim() || '',
        districtId: matchingDistrict ? matchingDistrict.id : '',
        buildingName: element.buildingName.trim() || '',
        buildingAbbr: element.buildingAbbreviation.trim() || '',
        buildingUrl: element.buildingUrl ? element.buildingUrl.trim() : '',
        buildingICalUrl: element.buildingICalUrl
          ? element.buildingICalUrl.trim()
          : '',
        bellTimeAM: element.bellTimeAM.trim() || '9:00',
        bellTimePM: element.bellTimePM.trim() || '3:15',
        grades: processedGrades || 'K-12',
        lat: coordinates.lat || 0,
        long: coordinates.long || 0,
      }

      const uploadDistrictData = await createBuilding(toUploadData)

      if (s === data.length - 1) {
        return {
          status: 200,
          message: 'Districts uploaded successfully',
        }
      }
    }
  } catch (error) {
    console.error(error)
  }
}
